import { connect, MapStateToProps } from "react-redux";

import { createGetAttributeNames, getConfigAttributes, getRecordById } from "@multiweb/reactCore/datasource";
import { IAppState } from "@multiweb/types/react";
import { DataRowTemplateComponentProps } from "../../../../components/DataRowTemplateComponent";
import { FrameSharedProps } from "../../../../types";
import { GRID_PARTICIPANTS_TEMPLATE_RENDERER_KEY } from "../../../constants";
import { GridParticipantsRowTemplateComponent } from "./GridParticipantsRowTemplateComponent";

export type GridParticipantsTemplateProps = FrameSharedProps;

type StateProps = Pick<DataRowTemplateComponentProps, "contentDataSourceAttributeNames" | "dataSourceAttributes">;

const createMapStateToProps: () => MapStateToProps<StateProps, GridParticipantsTemplateProps, IAppState> = () => {
    const getContentDataSourceAttributes = createGetAttributeNames(false);

    return (state, { dataSourceKey, recordId }) => ({
        rowTemplate: GRID_PARTICIPANTS_TEMPLATE_RENDERER_KEY,
        contentDataSourceAttributeNames: getContentDataSourceAttributes(state, dataSourceKey),
        dataSourceAttributes: getConfigAttributes(state, dataSourceKey),
        record: getRecordById(state, { dataSourceKey, recordId }),
    });
};

export const GridParticipantsTemplate = connect(createMapStateToProps)(GridParticipantsRowTemplateComponent);
